import List from 'containers/Banners/List';
import Edit from 'containers/Banners/Edit';
import Create from 'containers/Banners/Create';
import Show from 'containers/Banners/Show';

export default { List, Edit, Create, Show };
